/* Modulo: Review Spotlight
   Infinite 360° carousel + spotlight sync.
   Vanilla IIFE, theme-editor aware, reduced-motion aware. No dependencies. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var REDUCE =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSection(el) {
    if (!el || el.dataset.moduloTspInit === '1') return;
    el.dataset.moduloTspInit = '1';

    var rail = el.querySelector('[data-modulo-tsp-rail]');
    if (!rail) return;

    var prev = el.querySelector('[data-modulo-tsp-prev]');
    var next = el.querySelector('[data-modulo-tsp-next]');
    var dotsHost = el.querySelector('[data-modulo-tsp-dots]');

    var readMoreOn = el.getAttribute('data-read-more') === 'true';
    var moreLabel = el.getAttribute('data-read-more-label') || 'Read more';
    var lessLabel = el.getAttribute('data-read-less-label') || 'Read less';

    var originalCards = Array.prototype.slice.call(
      rail.querySelectorAll('.modulo-tsp__card')
    );
    var originalCount = originalCards.length;

    var activeVisualIndex = 0;
    var activeRealIndex = 0;
    var raf = null;
    var resizeT = null;
    var isJumping = false;
    var cloneCount = 0;

    function cards() {
      return Array.prototype.slice.call(
        rail.querySelectorAll('.modulo-tsp__card')
      );
    }

    function realIndexFromCard(card, fallbackIndex) {
      if (!card) return 0;
      var value = parseInt(card.getAttribute('data-real-index'), 10);
      if (!isNaN(value)) return value;
      return originalCount ? fallbackIndex % originalCount : 0;
    }

    function cardCenter(card) {
      return card.offsetLeft + card.clientWidth / 2;
    }

    function targetLeft(card) {
      return card.offsetLeft - (rail.clientWidth - card.clientWidth) / 2;
    }

    function setScrollLeft(left, behavior) {
      rail.scrollTo({
        left: left,
        behavior: behavior || 'auto'
      });
    }

    function markOriginalCards() {
      originalCards.forEach(function (card, index) {
        card.setAttribute('data-real-index', String(index));
        card.setAttribute('data-original-card', 'true');
      });
    }

    function createInfiniteTrack() {
      if (originalCount <= 1) return;

      markOriginalCards();

      /*
       * Clone enough cards on each side to fill the visible viewport.
       * Using the full original set gives a seamless loop even on wide screens.
       */
      cloneCount = originalCount;

      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();

      originalCards.forEach(function (card, index) {
        var endClone = card.cloneNode(true);
        endClone.removeAttribute('id');
        endClone.removeAttribute('data-original-card');
        endClone.setAttribute('data-clone', 'true');
        endClone.setAttribute('data-real-index', String(index));
        endClone.setAttribute('aria-hidden', 'true');
        after.appendChild(endClone);
      });

      originalCards
        .slice()
        .reverse()
        .forEach(function (card, reverseIndex) {
          var realIndex = originalCount - 1 - reverseIndex;
          var startClone = card.cloneNode(true);
          startClone.removeAttribute('id');
          startClone.removeAttribute('data-original-card');
          startClone.setAttribute('data-clone', 'true');
          startClone.setAttribute('data-real-index', String(realIndex));
          startClone.setAttribute('aria-hidden', 'true');
          before.insertBefore(startClone, before.firstChild);
        });

      rail.insertBefore(before, rail.firstChild);
      rail.appendChild(after);
    }

    function nearestVisualIndexForReal(realIndex) {
      var list = cards();
      var center = rail.scrollLeft + rail.clientWidth / 2;
      var best = -1;
      var bestDistance = Infinity;

      for (var i = 0; i < list.length; i++) {
        if (realIndexFromCard(list[i], i) !== realIndex) continue;
        var distance = Math.abs(cardCenter(list[i]) - center);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = i;
        }
      }

      return best;
    }

    function updateDots() {
      if (!dotsHost) return;
      var dots = dotsHost.children;

      for (var i = 0; i < dots.length; i++) {
        var on = i === activeRealIndex;
        dots[i].classList.toggle('is-active', on);
        dots[i].setAttribute('aria-selected', on ? 'true' : 'false');
        dots[i].setAttribute('tabindex', on ? '0' : '-1');
      }
    }

    function updateActive() {
      var list = cards();
      if (!list.length) return;

      var center = rail.scrollLeft + rail.clientWidth / 2;
      var best = 0;
      var bestDistance = Infinity;

      for (var i = 0; i < list.length; i++) {
        var distance = Math.abs(cardCenter(list[i]) - center);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = i;
        }
      }

      activeVisualIndex = best;
      activeRealIndex = realIndexFromCard(list[best], best);

      for (var j = 0; j < list.length; j++) {
        list[j].classList.toggle('is-active', j === best);
      }

      updateDots();

      /*
       * Infinite mode never disables arrows.
       * With one card, both controls are disabled.
       */
      if (prev) prev.disabled = originalCount <= 1;
      if (next) next.disabled = originalCount <= 1;
    }

    function normalizeLoopPosition() {
      if (originalCount <= 1 || isJumping) return;

      var list = cards();
      var firstOriginalIndex = cloneCount;
      var lastOriginalIndex = cloneCount + originalCount - 1;

      if (
        activeVisualIndex >= firstOriginalIndex &&
        activeVisualIndex <= lastOriginalIndex
      ) {
        return;
      }

      var matchingOriginal = list[firstOriginalIndex + activeRealIndex];
      if (!matchingOriginal) return;

      isJumping = true;
      var previousBehavior = rail.style.scrollBehavior;
      rail.style.scrollBehavior = 'auto';
      setScrollLeft(targetLeft(matchingOriginal), 'auto');

      window.requestAnimationFrame(function () {
        rail.style.scrollBehavior = previousBehavior;
        activeVisualIndex = firstOriginalIndex + activeRealIndex;
        updateActive();
        isJumping = false;
      });
    }

    function scrollToVisualIndex(index, behavior) {
      var list = cards();
      var card = list[index];
      if (!card) return;

      setScrollLeft(
        targetLeft(card),
        behavior || (REDUCE ? 'auto' : 'smooth')
      );
    }

    function scrollToRealIndex(realIndex) {
      if (!originalCount) return;

      var normalized =
        ((realIndex % originalCount) + originalCount) % originalCount;
      var visualIndex = nearestVisualIndexForReal(normalized);

      if (visualIndex < 0) return;
      scrollToVisualIndex(visualIndex);
    }

    function move(direction) {
      if (originalCount <= 1) return;

      var list = cards();
      var target = activeVisualIndex + direction;

      /*
       * There are clones on both sides, so this should always resolve.
       * The fallback protects against layout/editor edge cases.
       */
      if (target < 0 || target >= list.length) {
        scrollToRealIndex(activeRealIndex + direction);
        return;
      }

      scrollToVisualIndex(target);
    }

    function onScroll() {
      if (raf) return;

      raf = window.requestAnimationFrame(function () {
        raf = null;
        updateActive();

        window.clearTimeout(rail._moduloLoopTimer);
        rail._moduloLoopTimer = window.setTimeout(function () {
          updateActive();
          normalizeLoopPosition();
        }, REDUCE ? 0 : 90);
      });
    }

    rail.addEventListener('scroll', onScroll, { passive: true });

    function onPrev() {
      move(-1);
    }

    function onNext() {
      move(1);
    }

    if (prev) prev.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);

    function buildDots() {
      if (!dotsHost) return;

      dotsHost.innerHTML = '';

      for (var i = 0; i < originalCount; i++) {
        (function (index) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'modulo-tsp__dot';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', 'Go to review ' + (index + 1));
          dot.addEventListener('click', function () {
            scrollToRealIndex(index);
          });
          dotsHost.appendChild(dot);
        })(i);
      }
    }

    function setupReadMore() {
      if (!readMoreOn) return;

      cards().forEach(function (card) {
        var text = card.querySelector('.modulo-tsp__text');
        var button = card.querySelector('[data-modulo-tsp-more]');
        if (!text || !button) return;

        if (!card.classList.contains('is-expanded')) {
          button.textContent = moreLabel;
          button.hidden = text.scrollHeight - text.clientHeight <= 2;
        }

        if (button.dataset.wired === '1') return;
        button.dataset.wired = '1';

        button.addEventListener('click', function () {
          var open = card.classList.toggle('is-expanded');
          button.textContent = open ? lessLabel : moreLabel;

          window.requestAnimationFrame(function () {
            updateActive();
          });
        });
      });
    }

    function centerInitialCard() {
      var list = cards();
      if (!list.length) return;

      var initialIndex = originalCount > 1 ? cloneCount : 0;
      var initialCard = list[initialIndex];
      if (!initialCard) return;

      var previousBehavior = rail.style.scrollBehavior;
      rail.style.scrollBehavior = 'auto';
      setScrollLeft(targetLeft(initialCard), 'auto');

      window.requestAnimationFrame(function () {
        rail.style.scrollBehavior = previousBehavior;
        updateActive();
      });
    }

    function onResize() {
      window.clearTimeout(resizeT);
      resizeT = window.setTimeout(function () {
        setupReadMore();

        var list = cards();
        var originalCard =
          list[cloneCount + activeRealIndex] || list[activeVisualIndex];

        if (originalCard) {
          var previousBehavior = rail.style.scrollBehavior;
          rail.style.scrollBehavior = 'auto';
          setScrollLeft(targetLeft(originalCard), 'auto');

          window.requestAnimationFrame(function () {
            rail.style.scrollBehavior = previousBehavior;
            updateActive();
          });
        }
      }, 120);
    }

    window.addEventListener('resize', onResize);

    el.moduloTspTeardown = function () {
      window.removeEventListener('resize', onResize);
      rail.removeEventListener('scroll', onScroll);

      if (prev) prev.removeEventListener('click', onPrev);
      if (next) next.removeEventListener('click', onNext);

      window.clearTimeout(resizeT);
      window.clearTimeout(rail._moduloLoopTimer);

      if (raf) {
        window.cancelAnimationFrame(raf);
        raf = null;
      }

      Array.prototype.slice
        .call(rail.querySelectorAll('[data-clone="true"]'))
        .forEach(function (clone) {
          clone.remove();
        });

      el.dataset.moduloTspInit = '';
    };

    createInfiniteTrack();
    buildDots();
    rail.classList.add('is-ready');

    window.requestAnimationFrame(function () {
      setupReadMore();
      centerInitialCard();
    });
  }

  function initAll() {
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-tsp]', initSection);
    } else {
      var elements = document.querySelectorAll('[data-modulo-tsp]');
      for (var i = 0; i < elements.length; i++) {
        initSection(elements[i]);
      }
    }
  }

  function sectionTarget(event) {
    var target = event.target;
    if (!target || !target.querySelector) return null;
    if (target.matches && target.matches('[data-modulo-tsp]')) return target;
    return target.querySelector('[data-modulo-tsp]');
  }

  document.addEventListener('shopify:section:load', function (event) {
    var el = sectionTarget(event);
    if (el) initSection(el);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var el = sectionTarget(event);
    if (el && typeof el.moduloTspTeardown === 'function') {
      el.moduloTspTeardown();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
